import { ChatViewState } from '@type/chat';

interface BuildChatViewStateSnapshotArgs {
  scrollTop: number;
  anchorMessageId: string | undefined;
  activeTurnStartMessageId: string | undefined;
}

export const buildChatViewStateSnapshot = ({
  scrollTop,
  anchorMessageId,
  activeTurnStartMessageId,
}: BuildChatViewStateSnapshotArgs): ChatViewState => {
  const nextViewState: ChatViewState = {
    scrollTop,
  };

  if (anchorMessageId) {
    nextViewState.anchorMessageId = anchorMessageId;
  }

  if (activeTurnStartMessageId) {
    nextViewState.activeTurnStartMessageId = activeTurnStartMessageId;
  }

  return nextViewState;
};

export const areChatViewStatesEqual = (
  left: ChatViewState | undefined,
  right: ChatViewState | undefined
): boolean => {
  return (
    left?.scrollTop === right?.scrollTop &&
    left?.anchorMessageId === right?.anchorMessageId &&
    left?.activeTurnStartMessageId === right?.activeTurnStartMessageId
  );
};